<template>
  <div class="screenshots-preview" v-if="hasScreenshots" :class="{expanded: activeScreenshot}">
    <template v-if="!isLoading">
      <div class="screenshots-tiles-box">
        <div class="label">Snapshots</div>
        <div class="screenshots-tiles">
          <div class="arrows" @click="moveLeft" v-if="hasScroll">
            <fa-icon icon="chevron-left" size="2x"/>
          </div>
          <div class="tiles" ref="tiles">
            <div
              v-for="(screenshot, index) in currentSessionLog.screenshots"
              class="tile"
              ref="screenshot"
            >
              <div class="delete-screenshot" @click="deleteScreenshot(screenshot.id)">
                <img src="../../assets/icon_clear.svg"/>
              </div>
              <div
                class="screenshot"
                :class="{active: activeScreenshot && activeScreenshot.id === screenshot.id}"
                @click="setCurrentScreenshotIndex(index)"
              >
                <img :src="screenshot.path"/>
              </div>
            </div>
          </div>
          <div class="arrows" @click="moveRight" v-if="hasScroll">
            <fa-icon icon="chevron-right" size="2x"/>
          </div>
        </div>
      </div>
      <div class="screenshot-galerry" v-if="activeScreenshot"
           :style="{backgroundImage: `url(${activeScreenshot.path})`}">

      </div>
    </template>
    <loading-logo v-else :autoplay="true"/>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import LoadingLogo from "../LoadingLogo";

  const easeInQuad = (t) => {
    return t * t
  }

  export default {
    name: 'ScreenshotsPreview',
    components: {LoadingLogo},
    props: {
      sessionLog: {
        type: Object
      }
    },

    data: () => ({
      currentScreenshotIndex: -1,
      hasScroll: false,
      isLoading: false
    }),

    computed: {
      ...mapState({
        sessionLogsMap: state => state.sessions.map
      }),
      currentSessionLog() {
        return this.sessionLog && this.sessionLogsMap[this.sessionLog.id]
      },
      activeScreenshot() {
        return this.currentSessionLog && this.currentSessionLog.screenshots[this.currentScreenshotIndex]
      },
      hasScreenshots() {
        return this.currentSessionLog && this.currentSessionLog.screenshots.length
      }
    },

    methods: {
      setCurrentScreenshotIndex(index) {
        this.$nextTick()
          .then(() => {
            this.$emit('scrollScreenshots')
          })
        this.currentScreenshotIndex = index
      },
      close() {
        this.$emit('close')
      },
      handleKeyDown(e) {
        if (e.which === 27) {
          this.close()
        }
        if (e.which === 37) {
          this.keyboardMoveLeft()
        }

        if (e.which === 39) {
          this.keyboardMoveRight()
        }

      },
      moveRight() {
        if (!this.$refs.tiles) {
          return
        }
        let t = 0;
        let step = 0.06
        let interval = setInterval(() => {
          t += step;
          this.$refs.tiles.scrollLeft += Math.round(easeInQuad(t) * 50)
        }, 20);

        setTimeout(() => {
          clearInterval(interval)
        }, 300)
      },
      moveLeft() {
        if (!this.$refs.tiles) {
          return
        }
        let t = 0;
        let step = 0.06
        let interval = setInterval(() => {
          t += step;
          this.$refs.tiles.scrollLeft -= Math.round(easeInQuad(t) * 50)
        }, 20);

        setTimeout(() => {
          clearInterval(interval)
        }, 300)
      },

      keyboardMoveLeft() {
        if (this.currentScreenshotIndex > 0) {
          this.currentScreenshotIndex--
          this.$refs.screenshot[this.currentScreenshotIndex].scrollIntoView();
        }
      },

      keyboardMoveRight() {
        if (this.currentScreenshotIndex < this.currentSessionLog.screenshots.length - 1) {
          this.currentScreenshotIndex++
          this.$refs.screenshot[this.currentScreenshotIndex].scrollIntoView();
        }
      },

      deleteScreenshot(id) {
        this.isLoading = true;
        this.$store.dispatch('screenshots/deleteScreenshot', {id, sessionId: this.currentSessionLog.id})
          .then(() => {
            this.isLoading = false;
            this.$nextTick()
              .then(() => {
                if (!this.activeScreenshot) {
                  this.currentScreenshotIndex = 0;
                }
              })
          })
          .catch(() => {
            this.isLoading = false;
          })
      }
    },

    mounted() {
      document.addEventListener('keydown', this.handleKeyDown, false)
      this.currentScreenshotIndex = -1;
      this.$nextTick()
        .then(() => {
          this.hasScroll = this.$refs.tiles && this.$refs.tiles.scrollWidth > this.$refs.tiles.clientWidth;
        })
    },

    watch: {
      sessionLog() {
        this.currentScreenshotIndex = -1
        this.$nextTick()
          .then(() => {
            this.hasScroll = this.$refs.tiles && this.$refs.tiles.scrollWidth > this.$refs.tiles.clientWidth;
          })
      }
    },

    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeyDown, false)
    }
  }
</script>

<style lang="scss">
  @import "ScreenshotsPreview";
</style>
